import { render, staticRenderFns } from "./ModalTextarea.vue?vue&type=template&id=3f1f236b"
import script from "./ModalTextarea.vue?vue&type=script&lang=js"
export * from "./ModalTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports